import { Fragment } from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import  "highcharts/modules/no-data-to-display";
import { Card } from "antd";

// Initialize the no-data module

export const BoothRequest = ({ data }: any) => {
  const boothData = data?.[0] || {};

  // Check if there is any data
  const hasData =
    (boothData.ConfirmedCount || 0) +
    (boothData.PendingCount || 0) +
    (boothData.RejectedCount || 0) > 0;

  const chartData = [
    { name: "Confirmed", y: boothData.ConfirmedCount || 0, color: "#4caf50" },
    { name: "Pending", y: boothData.PendingCount || 0, color: "#ffc107" },
    { name: "Rejected", y: boothData.RejectedCount || 0, color: "#f44336" },
  ];

  const options: Highcharts.Options = {
    chart: {
      type: "pie",
      backgroundColor: "transparent",
    },
    title: {
      text: "Booth Request",
      style: { fontSize: "18px", fontWeight: "bold" },
    },
    credits: { enabled: false },
    lang: { noData: "No data found" }, // message when no data
    noData: { style: { fontWeight: "bold", fontSize: "16px", color: "#666" } },
    tooltip: {
      pointFormat: "{series.name}: <b>{point.y}</b> ({point.percentage:.1f}%)",
    },
    plotOptions: {
      pie: {
        allowPointSelect: true,
        cursor: "pointer",
        dataLabels: {
          enabled: true,
          format: "<b>{point.name}</b>: {point.y}",
          style: { fontSize: "14px" },
        },
      },
    },
    series: hasData
      ? [
          {
            name: "Sales",
            type: "pie",
            data: chartData,
          },
        ]
      : [],
  };

  return (
    <Fragment>
      <Card>
        <HighchartsReact highcharts={Highcharts} options={options} />
      </Card>
    </Fragment>
  );
};
